module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('h2', [_vm._v(_vm._s(_vm.campaign.name))]), _c('span', {
    staticClass: "campaign-code"
  }, [_vm._v("ID: " + _vm._s(_vm.campaign.code))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-012a2c84"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-heading/CampaignHeading.vue
// module id = 1995
// module chunks = 1